import React, { useState } from 'react';
import './NewsletterSubscribe.css';

interface NewsletterSubscribeProps {
  inline?: boolean;
}

const NewsletterSubscribe: React.FC<NewsletterSubscribeProps> = ({ inline = false }) => {
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage(null);

    try {
      const response = await fetch('https://api.theacademicloft.com/subscribe', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email,
          firstName
        })
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setMessage({ type: 'success', text: data.message });
        setEmail('');
        setFirstName('');
      } else {
        setMessage({
          type: 'error',
          text: data.error || 'Unable to subscribe. Please try again later.'
        });
      }
    } catch (error) {
      console.error('Error subscribing to newsletter:', error);
      setMessage({
        type: 'error',
        text: 'Unable to subscribe. Please try again later.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  if (inline) {
    return (
      <div className="newsletter-subscribe-inline">
        <form onSubmit={handleSubmit} className="newsletter-form-inline">
          <input
            type="email"
            placeholder="Your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isSubmitting}
            className="newsletter-input-inline"
          />
          <button
            type="submit"
            disabled={isSubmitting}
            className="newsletter-button-inline"
          >
            {isSubmitting ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>
        {message && (
          <div className={`newsletter-message-inline ${message.type}`}>
            {message.text}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="newsletter-subscribe">
      <h3 className="newsletter-title">Stay Updated</h3>
      <p className="newsletter-description">
        Subscribe to our newsletter for special offers and updates about Academic Loft.
      </p>
      <form onSubmit={handleSubmit} className="newsletter-form">
        <div className="newsletter-input-group">
          <input
            type="text"
            placeholder="First name (optional)"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            disabled={isSubmitting}
            className="newsletter-input"
          />
          <input
            type="email"
            placeholder="Email address *"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isSubmitting}
            className="newsletter-input"
          />
        </div>
        <button
          type="submit"
          disabled={isSubmitting}
          className="newsletter-button"
        >
          {isSubmitting ? 'Subscribing...' : 'Subscribe to Newsletter'}
        </button>
      </form>
      {message && (
        <div className={`newsletter-message ${message.type}`}>
          {message.text}
        </div>
      )}
    </div>
  );
};

export default NewsletterSubscribe;
